var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 61,
    viewBox: "0 0 62 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3104_374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.9921 1.38049C35.6172 1.03763 43.5428 0.473731 50.5161 5.7021C61.9641 14.2485 59.902 30.3703 59.7968 31.2054C58.5285 40.0447 53.3558 45.6756 50.6639 48.5875C47.1555 52.3796 40.309 59.8294 29.8451 59.9989C21.0505 60.0928 14.8562 54.8895 12.3901 52.8222C10.6327 51.3498 1.04007 43.3027 1.09994 30.1554C1.18211 23.6687 3.46505 17.4014 7.57612 12.3767C15.6056 2.46814 27.3655 1.62471 30.9921 1.38049Z",
    stroke: "black",
    strokeWidth: 0.55926,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3104_374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5828 38.0354C23.1287 38.859 21.6144 39.5713 20.0527 40.1661C18.375 40.8093 15.1592 42.0844 14.2364 41.061C13.4703 40.1997 14.7957 38.2087 15.355 37.4146C15.7353 36.8553 17.8157 33.7682 22.5359 30.312C24.6864 28.7172 27.0064 27.3649 29.4539 26.2797C33.6484 24.5013 34.9347 25.4688 35.3261 25.7652C35.8351 26.1399 36.7019 26.7886 35.4268 28.8579C34.2691 30.7314 31.937 32.8007 30.0299 34.3163",
    stroke: "black",
    strokeWidth: 1.11852,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2869 23.8467C36.9439 22.7455 38.7046 21.8089 40.5439 21.0504C44.7999 19.3726 46.1812 20.4408 46.6007 20.7819C47.1599 21.207 48.0715 21.9396 46.8524 24.0816C44.839 27.6105 38.8717 31.626 38.5585 31.8385C36.3642 33.3234 33.9885 34.5206 31.4895 35.401C29.8117 36.005 26.5177 37.2074 25.5166 36.0777C24.6777 35.1214 25.9752 33.0577 26.4897 32.2412C27.1878 31.147 27.9874 30.1209 28.8777 29.1764",
    stroke: "black",
    strokeWidth: 1.11852,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3104_374"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59.8408,
    height: 59.8408,
    fill: "white",
    transform: "translate(0.0263672 59.8293) rotate(-88.8791)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3104_374"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.5679,
    height: 22.4263,
    fill: "white",
    transform: "translate(13.4482 19.5742)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link-icon.d142685e174271178ed75d90ea5fd59f.svg";
export { ForwardRef as ReactComponent };